export class AuthToken {
    token: string;
    expiration: Date;
    lastLoggedOn: Date;
}


// WEBPACK FOOTER //
// ./src/app/+auth/auth.token.ts